module.exports = __webpack_public_path__ + "static/media/publicity.7ff1eeb1.jpg";